<template>
  <div class="dem-imp-xml-itens">
    <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- APRESENTA O CONTEUDO DA TELA -->
    <template v-else-if='statusGeral === ""'>
      <App-Tabela
      :cpntColuna="colunas"
      :cpntLinha="linhas"
      cpntKeyValueEditar="nItem"
      ref="tabela">
        <template v-slot:titulo>
          <div class="dem-imp-xml-itens--legenda noselect">
            <div class="info">
              <div class="quadrado background-tp-1">&nbsp;</div>
              <div>
                Relação produto Fornecedor x Cliente encontrada.
              </div>
            </div>

            <div class="info">
              <div class="quadrado background-tp-4">&nbsp;</div>
              <div>
                Código de Barras encontrado no cadastro.
              </div>
            </div>

            <div class="info">
              <div class="quadrado background-tp-3">&nbsp;</div>
              <div>
                Nome encontrado no cadastro.
              </div>
            </div>

            <div class="info">
              <div class="quadrado background-tp-2">&nbsp;</div>
              <div>
                Nenhuma semelhança encontrada no cadastro.
              </div>
            </div>
          </div>
        </template>

        <template v-slot:col_id_pro_codigo="{ linha, valor, linhaAdd }">
          <!-- SETA O NOME DO XML -->
          <div v-html="valor"></div>

          <!-- SETA O BOTÃO DO CAMPO -->
          <App-Button @onClick="() => { demImpXmlItensOnChangeLinhaAdicional(linha) }">
            <div :key="'dividir-icon--' + linhaAdd">
              <span v-show="linhaAdd === false">
                <svg class="fas fa-divide"></svg>
              </span>
              <span v-show="linhaAdd === true">
                <svg class="fas fa-minus"></svg>
              </span>
            </div>
          </App-Button>
        </template>

        <template v-slot:col_id_pro_nome="{ linha, valor, indexL, linhaAdd }">
          <!-- SETA O NOME DO XML -->
          <div v-html="valor"></div>

          <!-- SETA O AUTOCOMPLITE PARA BUSCAR -->
          <App-Autocompletar :data-time="time" v-if="linhaAdd === false && linha._fundoF !== 'background-tp-4'"
          :cpntStatus='linha.produto.status'
          :cpntId='linha.produto.id'
          :class='linha.produto.class'
          :cpntTabIndex='linha.produto.tabIndex'
          :cpntNome='linha.produto.nome'
          :cpntValue='linha.produto.value'
          :cpntMensagem='linha.produto.mensagem'
          :cpntMensagemTipo='linha.produto.mensagemTipo'
          :cpntDisabled='linha.produto.disabled'
          :cpntMostrar='linha.produto.mostrar'
          :cpntExplica='linha.produto.explica'
          :cpntPlaceholder='linha.produto.placeholder'
          :cpntValueRef='linha.produto.valueRef'
          :cpntRouter='linha.produto.router'
          :cpntMethod='linha.produto.method'
          :cpntField='linha.produto.field'
          :cpntWhere='linha.produto.where'
          :cpntAddButForm='linha.produto.addButForm'
          :cpntKeyMostra='linha.produto.keyMostra'
          :cpntTipoOrder='linha.produto.tipoOrder'
          :cpntOrder='linha.produto.order'
          :cpntOptions='linha.produto.options'
          :cpntKeyValue='linha.produto.keyValue'
          :cpntSearchMinimo='linha.produto.searchMinimo'
          :cpntMask='linha.produto.mask'
          :cpntOptionInicialNome='linha.produto.optionInicialNome'
          :cpntOptionInicialValue='linha.produto.optionInicialValue'
          :cpntNewOption='linha.produto.newOption'

          :cpntOnChange='(value) => { demImpXmlItensOnChangeValue(value, indexL, "produto") }'
          :cpntOnRealizaBusca='(busca) => { demImpXmlItensOnRealizarBusca(indexL, "produto", busca) }'
          ></App-Autocompletar>
        </template>

        <template v-slot:col__usar="{ linha, indexL, indexCV }">
          <template v-if="linha._usar === ''">
            ---
          </template>

          <App-Toggles v-else :data-time="time"
          :cpntStatus='linha._usar.status'
          :cpntClassDivField='linha._usar.classDivField'
          :cpntNome='linha._usar.nome'
          :cpntValue='linha._usar.value'
          :cpntDisabled='linha._usar.disabled'
          :cpntMostrar='linha._usar.mostrar'
          :cpntMensagem='linha._usar.mensagem'
          :cpntMensagemTipo='linha._usar.mensagemTipo'
          :cpntOn='linha._usar.on'
          :cpntOff='linha._usar.off'
          :cpntExplica='linha._usar.explica'
          :cpntWidth='linha._usar.width'
          :cpntTabIndex='linha._usar.tabIndex'

          :cpntOnChange='(value) => { demImpXmlItensOnChangeValue(value, indexL, indexCV) }'
          ></App-Toggles>
        </template>

        <template v-slot:converte="{ indexL, indexCV }">
          <span v-html="demImpXmlItensPegarValorCampo(indexL, indexCV)"></span>
        </template>

        <template v-slot:linha_adicional="{ linha, indexL }">
          <div>
            <App-Demanda-Importar-Xml-Dividir
            :cpntIndexFile="'--' + cpntIndexFile + '--' + indexL"
            :cpntDados="linha"
            :cpntPreAnalise="cpntPreAnalise[linha.nItem]"
            :ref="'item--' + indexL"
            ></App-Demanda-Importar-Xml-Dividir>
          </div>
        </template>
      </App-Tabela>
    </template>
  </div>
</template>

<style scoped>
.dem-imp-xml-itens {
  padding-top: 5px;
}

.dem-imp-xml-itens--legenda {
  text-align: center;
}
  .dem-imp-xml-itens--legenda > .info {
    display: inline-block;
    margin: 5px 10px;
  }
    .dem-imp-xml-itens--legenda > .info > div {
      display: inline-block;
      vertical-align: middle;
    }
    .dem-imp-xml-itens--legenda > .info > .quadrado {
      width: 25px;
      height: 25px;
      border-radius: 4px;
      margin-right: 5px;
    }
    .dem-imp-xml-itens--legenda > .info > .quadrado.background-tp-2 { /* COR: VERMELHO */
      -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
      -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
      box-shadow: inset 0px 1px 0px 0px #ffffff;
      background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f7c6c6), color-stop(1, #ecc5bd) );
      background: -moz-linear-gradient( center top, #f7c6c6 5%, #ecc5bd 100% );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7c6c6', endColorstr='#ecc5bd');
      background-color: #f7c6c6;
      text-decoration: none;
    }
    .dem-imp-xml-itens--legenda > .info > .quadrado.background-tp-3 { /* COR: AMARELO */
      -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
      -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
      box-shadow: inset 0px 1px 0px 0px #ffffff;
      background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f4f1c3), color-stop(1, #ece9bd) );
      background: -moz-linear-gradient( center top, #f4f1c3 5%, #ece9bd 100% );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f1c3', endColorstr='#ece9bd');
      background-color: #f4f1c3;
      text-decoration: none;
    }
    .dem-imp-xml-itens--legenda > .info > .quadrado.background-tp-4 { /* COR: VERDE */
      -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
      -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
      box-shadow: inset 0px 1px 0px 0px #ffffff;
      background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #cdfacd), color-stop(1, #bdecbd) );
      background: -moz-linear-gradient( center top, #cdfacd 5%, #bdecbd 100% );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cdfacd', endColorstr='#bdecbd');
      background-color: #cdfacd;
      text-decoration: none;
    }
</style>

<style>
  .dem-imp-xml-itens > table > tbody > tr > td > div {
    min-height: 40px;
  }
    .dem-imp-xml-itens > table > tbody > tr > td.col_id_pro_codigo > div > span > button {
      margin: 5px 0px;
    }
    .dem-imp-xml-itens > table > tbody > tr > td.col_id_pro_nome > div > span {
      display: inline-block;
      vertical-align: middle;
    }
    .dem-imp-xml-itens > table > tbody > tr > td.col_id_pro_nome > div > span > button {
      width: 35px;
      height: 30px;
      padding: 0px;
      margin: 0px;
    }
    .dem-imp-xml-itens > table > tbody > tr > td.col_id_pro_nome > div > span > .cpnt-app-autocompletar {
      max-width: 250px !important;
      margin: 5px 5px;
    }
    .dem-imp-xml-itens > table > tbody > tr > td.col__usar > div > span > div {
      margin-bottom: 0px;
      width: 100% !important;
      padding: 4px !important;
    }
      .dem-imp-xml-itens > table > tbody > tr > td.col__usar > div > span > div > div {
        width: 80% !important;
      }
</style>

<script>
// IMPORTA A FUNÇÃO UTILIZADA
import { PEGAR_VALOR_CHAVE_XML } from '@/assets/js/Funcoes-Gerais.js'

export default {
  props: {
    cpntIndexFile: {
      required: true
    },
    cpntFileConteudo: {
      required: true
    },
    cpntPreAnalise: {
      required: true
    }
  },
  components: {
    'App-Demanda-Importar-Xml-Dividir': () => import('./Demanda-Importar-Xml-Dividir')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      colunas: [
        { mPer: 1,                    chave: 'id_pro_codigo',       nome: 'Cód.'                               },
        { mPer: 2,                    chave: 'id_pro_nome',         nome: 'Produto'                            },
        { mPer: 1,                    chave: 'id_pro_ncm',          nome: 'NCM/SH'                             },
        { mPer: 1,                    chave: '_usar',               nome: 'Utilizar a medida'                  },
        { mPer: 1,  slot: 'converte', chave: '_cod_barra',          nome: 'Cód. Barras'                        },
        { mPer: 1,  slot: 'converte', chave: 'id_uni',              nome: 'Unidade'                            },
        { mPer: 1,  slot: 'converte', chave: '_qtde',               nome: 'Quantidade'                         },
        { mPer: 1,  slot: 'converte', chave: '_valor_uni',          nome: 'Valor Unitário'                     },
        { mPer: 1,                    chave: '_valor_tot',          nome: 'Valor Total	'                      }
      ],
      linhas: []
    }
  },
  mounted: function () {
    this.demImpXmlItensIniciar()
  },
  methods: {
    demImpXmlItensIniciar: function () {
      // INICIA A FUNÇÃO DE LEITURA
      var parser = new DOMParser()

      // CARREGA O XML RECEBIDO
      var xml = parser.parseFromString(this.cpntFileConteudo, 'text/xml')

      // PEGA OS DADOS DA NFE
      var infNFe = PEGAR_VALOR_CHAVE_XML(xml, 'infNFe')

      // CARREGA OS ITENS DA COMPRA
      var itens = PEGAR_VALOR_CHAVE_XML(infNFe, 'det', false)

      // RODA O VETOR ADICIONANDO OS VALORES
      for (var index in itens) {
        if ([ '', null, undefined ].indexOf(itens[index]) === -1 && typeof itens[index] === 'object') {
          // INICIA A VARIAVEL
          var linha = {}

          // SETA O NOME DO PRODUTO
          linha.id_pro_nome = PEGAR_VALOR_CHAVE_XML(itens[index], 'xProd')

          // PEGA O NUMERO DO ITEM NO XML
          linha.nItem = itens[index].getAttribute('nItem')

          // // VERIFICA SE NÃO É O PRODUTO DE HOMOLOGAÇÃO
          // if ([ 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL' ].indexOf(linha.id_pro_nome) === -1) {
          // SETA O CODIGO DO PRODUTO
          linha.id_pro_codigo = PEGAR_VALOR_CHAVE_XML(itens[index], 'cProd')
          
          // SETA A NCM DO PRODUTO
          linha.id_pro_ncm = PEGAR_VALOR_CHAVE_XML(itens[index], 'NCM')
          linha.id_pro_cest = PEGAR_VALOR_CHAVE_XML(itens[index], 'CEST')

          // SETA O VALOR TOTAL DO PRODUTO
          linha.valor_tot = PEGAR_VALOR_CHAVE_XML(itens[index], 'vProd')

          // PEGA OS DADOS DA CAIXA
          linha.qtde_com        = PEGAR_VALOR_CHAVE_XML(itens[index], 'qCom')
          linha.valor_uni_com   = PEGAR_VALOR_CHAVE_XML(itens[index], 'vUnCom')
          linha.cod_barra_com   = PEGAR_VALOR_CHAVE_XML(itens[index], 'cEAN')
          linha.id_uni_com      = PEGAR_VALOR_CHAVE_XML(itens[index], 'uCom')

          // PEGA OS DADOS DO ITEM DENTRO DA CAIXA
          linha.qtde_trib       = PEGAR_VALOR_CHAVE_XML(itens[index], 'qTrib')
          linha.valor_uni_trib  = PEGAR_VALOR_CHAVE_XML(itens[index], 'vUnTrib')
          linha.cod_barra_trib  = PEGAR_VALOR_CHAVE_XML(itens[index], 'cEANTrib')
          linha.id_uni_trib     = PEGAR_VALOR_CHAVE_XML(itens[index], 'uTrib')

          // FORMATA OS VALORES RECEBIDOS
          linha._qtde_com         = this.$store.state.FUN_MASK_VALOR('valorDecimal', linha.qtde_com)
          linha._valor_uni_com    = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linha.valor_uni_com)
          linha._qtde_trib        = this.$store.state.FUN_MASK_VALOR('valorDecimal', linha.qtde_trib)
          linha._valor_uni_trib   = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linha.valor_uni_trib)
          linha._valor_tot        = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linha.valor_tot)

          // VERIFICA SE TEM CODIGO DE BARRAS DO PRODUTO
          linha._cod_barra_com = linha.cod_barra_com
          if ([ '', null, undefined, 'SEM GTIN' ].indexOf(linha.cod_barra_com) !== -1) {
            linha._cod_barra_com = ''
          }
          linha._cod_barra_trib = linha.cod_barra_trib
          if ([ '', null, undefined, 'SEM GTIN' ].indexOf(linha.cod_barra_trib) !== -1) {
            linha._cod_barra_trib = ''
          }

          // SETA O VALOR QUE DEVE UTILIZAR
          linha._usar = ''

          // VERIFICA SE DEVE UTILIZAR UNIDADE COMERCIAL PARA CAIXA OU UNIDADE
          if (linha.qtde_com !== linha.qtde_trib) {
            linha._usar = {
              id: 'dem-imp-xml-itens--' + this.linhas.length,
              status: '',
              nome: '',
              on: linha.id_uni_trib,
              off: linha.id_uni_com,
              value: true
            }
          }

          linha.produto = {
            id: 'dem-imp-xml-itens-produto--' + this.linhas.length,
            status: '',
            nome: '',
            router: '/produto/get',
            method: 'POST',
            field: { id: { a: 'id_pro' }, nome: { a: 'id_pro_nome' } },
            where: 'dem-edi-pro',
            keyValue: 'id_pro',
            keyMostra: [ 'id_pro_nome' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demImpXmlItensOnNovoProduto
            },
            apiEnv: 'id_pro',
            value: '',
            // valueRef: '',
            mostrar: true
          }

          // ADICIONA O VALOR NO VETOR
          this.linhas.push(linha)
        }
        // }
      }
      
      // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
      this.demImpXmlItensTratarPreAnalise('todos', () => { this.demImpXmlItensSetarStatusGeral('') })
    },
    demImpXmlItensOnNovoProduto: function (string, id) {
      this.$store.state.comunicaAPI('/produto/unidade/get', 'GET', null, (registros) => {
        // ADICIONA A UNIDADE NO CAMPO
        registros.data.unshift({ id: '', nome: 'Igual ao campo unidade' })

        // PEGA O ID DA LINHA
        var index = id.split('--')[1]
  
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'produto', id: 0 }
  
        // SETA O VETOR DO CAMPO
        params.vetor = {
          nome: string,
          ncm: this.linhas[index].id_pro_ncm,
          cest: this.linhas[index].id_pro_cest,
          valor_for: this.demImpXmlItensPegarValorCampo(index, '_valor_uni'),
          cod_barra: this.demImpXmlItensPegarValorCampo(index, '_cod_barra'),
          id_uni: this.linhas[index].id_uni_com,
        }

        // PEGA A UNIDADE ENCONTRADA PARA O CAMPO
        params.vetor.id_uni = registros.data.filter(item => item.id === params.vetor.id_uni)

        // VERIFICA SE ENCONTROU ALGUMA UNIDADE
        params.vetor.id_uni = params.vetor.id_uni.length >= 1 ? params.vetor.id_uni[0] : ''

        // VERIFICA SE DEVE ALTERAR A UNIDADE TRIBUTARIA
        if (this.linhas[index]._usar !== '' && this.linhas[index]._usar.value === true) {
          // CARREGA A UNIDADE TRIBUTARIA
          params.vetor.id_uni_trib = this.linhas[index].id_uni_trib

          // PEGA A UNIDADE ENCONTRADA PARA O CAMPO
          params.vetor.id_uni_trib = registros.data.filter(item => item.id === params.vetor.id_uni_trib)

          // VERIFICA SE ENCONTROU ALGUMA UNIDADE
          params.vetor.id_uni_trib = params.vetor.id_uni_trib.length >= 1 ? params.vetor.id_uni_trib[0] : ''

          // SETA A QUATNIDADE TRIBUTARIA DO CAMPO
          params.vetor.qtde_trib = this.linhas[index].qtde_trib

          // SETA O CODIGO DE BARRAS TRIBUTARIO
          params.vetor.cod_barra_trib = this.linhas[index]._cod_barra_trib
        }
  
        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            // SETA OS DADOS RECEBIDOS
            this.linhas[index].produto.value = { id_pro: dados.id, id_pro_nome: dados.nome, _busca: dados.nome }
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }
  
        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      }, this.demImpXmlItensSetarStatusGeral)
    },
    demImpXmlItensTratarPreAnalise: function (vetor, callback = null) {
      if (vetor === 'todos') {
        vetor = Object.keys(this.linhas)
      } else if (typeof vetor === 'string' || typeof vetor === 'number') {
        vetor = [ vetor ]
      }

      // TRATA A PRÉ ANALISE DO CAMPO
      for (var index in vetor) {
        // PEGA O NUMERO DA LINHA QUE DEVE TRABALHAR
        var indexL = vetor[index]

        // PEGA O NUMERO DO ITEM NO XML
        var nItem = this.linhas[indexL].nItem

        // INICIA A VARIAVEL
        var preAnalise = null

        // VERIFICA SE FOI ENCONTRADO OS DADOS DO ITEM
        if ([ '', null, undefined ].indexOf(this.cpntPreAnalise) === -1 && [ '', null, undefined ].indexOf(this.cpntPreAnalise[nItem]) === -1) {
          // VERIFICA SE NÃO FOI ENCONTRADO O CAMPO
          if (preAnalise === null && [ '', null, undefined ].indexOf(this.cpntPreAnalise[nItem].cProd) === -1) {
            // SETA PRE ANALISE
            preAnalise = this.cpntPreAnalise[nItem].cProd

            // SETA QUE O NOME FOI IDENTIFICADO
            this.linhas[indexL]._fundoN = 'background-tp-1'
            this.linhas[indexL]._fundoF = 'background-tp-1'
          }
          
          // VERIFICA SE TEM PRE ANALISE SELECIONADA
          if (preAnalise === null) {
            // VERIFICA CONFORME A UNIDADE QUE DEVE UTILIZAR
            switch (this.demImpXmlItensUsarUnidade(indexL)) {
              case 'trib':
                if ([ '', null, undefined ].indexOf(this.cpntPreAnalise[nItem].ceanTrib) === -1) {
                  preAnalise = this.cpntPreAnalise[nItem].ceanTrib
                }
                break
              
              case 'com':
                if ([ '', null, undefined ].indexOf(this.cpntPreAnalise[nItem].cean) === -1) {
                  preAnalise = this.cpntPreAnalise[nItem].cean
                }
                break
            }

            // VERIFICA SE O ITEM FOI ENCONTRADO PELO CODIGO DE BARRAS
            if (preAnalise !== null) {
              this.linhas[indexL]._fundoN = 'background-tp-4'
              this.linhas[indexL]._fundoF = 'background-tp-4'
            }
          }

          // VERIFICA SE NÃO FOI ENCONTRADO O CAMPO
          if (preAnalise === null && [ '', null, undefined ].indexOf(this.cpntPreAnalise[nItem].nome) === -1) {
            // SETA PRE ANALISE
            preAnalise = this.cpntPreAnalise[nItem].nome

            // SETA QUE O NOME FOI IDENTIFICADO
            this.linhas[indexL]._fundoN = 'background-tp-3'
            this.linhas[indexL]._fundoF = 'background-tp-3'
          }

          // SETA O VALOR ENCONTRADO PARA O CAMPO
          this.linhas[indexL].produto.value = (preAnalise !== null ? preAnalise : '')
        }

        // VERIFICA SE O ITEM FOI ENCONTRADO PELO CODIGO DE BARRAS
        if (preAnalise === null) {
          this.linhas[indexL]._fundoN = 'background-tp-2'
          this.linhas[indexL]._fundoF = 'background-tp-2'
        }
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
      
      // VERIFICA SE TEM CALLBACK PARA EXECUTAR
      if (callback !== null && typeof callback === 'function') {
        callback()
      }
    },
    demImpXmlItensOnRealizarBusca: function (indexL, indexCV, busca) {
      // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
      this.linhas[indexL][indexCV].value = ''
      this.linhas[indexL][indexCV].valueRef = ''
      
      // SETA O VALOR DIGITADO NA BUSCA
      this.linhas[indexL][indexCV]._busca = busca

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    demImpXmlItensOnChangeValue: function (value, indexL, indexCV) {
      // SETA O VALOR RECEBIDO
      this.linhas[indexL][indexCV].value = value

      // VERIFICA O CAMPO QUE FOI ATUALIZADO
      switch (indexCV) {
        case '_usar':
          this.demImpXmlItensTratarPreAnalise(indexL)
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    demImpXmlItensPegarValorCampo: function (indexL, indexCV) {
      // VERIFICA O VALOR QUE DEVE UTILIZAR
      var opcao = this.demImpXmlItensUsarUnidade(indexL)

      // MONTA O NOME DA CHAVE QUE DEVE RETORNAR
      var chave = indexCV + '_' + opcao

      // RETORNA O VALOR SOLICITADO
      return this.linhas[indexL][chave]
    },
    demImpXmlItensUsarUnidade: function (indexL) {
      return (this.linhas[indexL]._usar === '' || this.linhas[indexL]._usar.value === true ? 'trib' : 'com')
    },
    demImpXmlItensSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    demImpXmlItensOnChangeLinhaAdicional: function (linha) {
      this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(linha.nItem)
    }
  },
  watch: {
    cpntFileConteudo: function () {
      this.demImpXmlItensIniciar()
    }
  }
}
</script>
